import React, { useEffect, useState, useCallback } from "react";
import CreateUsuarioRS from "../organisms/usuariosRS/CreateUsuarioRS";
import TableUsuariosRS from "../organisms/usuariosRS/TableUsuariosRS";
import CardTables from "../atoms/CardTables";
import { GET_USERS_RS } from "../../api/apiAdmin";
import Fuse from "fuse.js";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";
import Button from "../atoms/Button";
import { FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";

const UsuariosRSTemplate = () => {
	const [usuarios, setUsuarios] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [filteredUsuarios, setFilteredUsuarios] = useState([]);

	const getUsers = async () => {
		try {
			setLoading(true);
			const usersData = await GET_USERS_RS();
			const sortedData = usersData.sort((a, b) => a.actualNode - b.actualNode);
			setUsuarios(sortedData);
			setFilteredUsuarios(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getUsers();
	}, []);

	useEffect(() => {
		if (!usuarios) return;

		const fuse = new Fuse(usuarios, {
			keys: ["name", "email"],
			threshold: 0.3,
		});

		if (searchTerm.trim()) {
			const results = fuse.search(searchTerm.trim()).map((r) => r.item);
			setFilteredUsuarios(results);
		} else {
			setFilteredUsuarios(usuarios);
		}
	}, [searchTerm, usuarios]);

	const findFather = useCallback(
		(nodeJefe) => {
			if (!nodeJefe || !Array.isArray(usuarios)) return "Sin jefe directo";
			const jefe = usuarios.find((row) => row.actualNode === nodeJefe);
			return jefe?.name || "Sin jefe directo";
		},
		[usuarios]
	);

	const handleExportExcel = () => {
		if (!filteredUsuarios || filteredUsuarios.length === 0) return;

		const dataToExport = filteredUsuarios.map((u) => ({
			Nombre: u.name || "",
			Correo: u.email || "",
			Posición: u.position || "",
			"Jefe Directo": findFather(u.parentNode),
		}));

		const worksheet = XLSX.utils.json_to_sheet(dataToExport);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");

		// Auto-size columns
		const colWidths = Object.keys(dataToExport[0]).map((key) => ({
			wch: Math.max(
				key.length,
				...dataToExport.map((row) => (row[key] || "").toString().length)
			) + 2,
		}));
		worksheet["!cols"] = colWidths;

		XLSX.writeFile(workbook, "usuarios_despacho.xlsx");
	};

	return (
		<div className="flex flex-col space-y-2">
			<CardHeader>
				<Breadcrumb
                    items={[
                        { label: "Usuarios", to: "/usuarios" },
                        { label: "Usuarios despacho", to: null },
                    ]}
                />
				<div className="flex flex-row space-x-2">
					<Button
						text={<FaFileExcel size={22} />}
						bgColor="green"
						onClick={handleExportExcel}
						width="w-10"
					/>
					<CreateUsuarioRS refetch={getUsers} usuarios={usuarios} />
				</div>
			</CardHeader>
			<CardTables>
				<div className="mb-4">
					<input
						type="text"
						placeholder="Buscar por nombre o email"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className="border p-2 rounded w-full md:w-1/3"
					/>
				</div>
				<TableUsuariosRS
					data={filteredUsuarios}
					refetch={getUsers}
					loading={loading}
				/>
			</CardTables>
		</div>
	);
};

export default UsuariosRSTemplate;
